import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceInfoAxios from '../../../../utils/axios/deviceInfo.axios';

const tryToFetchNotifications = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/hotel-world-notifications/transaction_review?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/hotel-world-notifications/transaction_review?page=${pageNumber}&size=${pageSize}`;
    return deviceInfoAxios.put<any>(url, data);
};

const tryToMarkNotificationsAsRead = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.put(`${DEVICE_INFO_API_URL}/hotel-world-notifications/transaction_review/read`, data);
};

export const NotificationsService = {
    tryToFetchNotifications,
    tryToMarkNotificationsAsRead
};